// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"930a6f97","513":"78ca5636"}[chunkId] + ".chunk.js";
};